var Reverb = window.Reverb || {};
Reverb.AjaxFetchOnPageLoad = (function () {
  var fetchOnPageLoad = '[data-fetch-on-load]';

  function init() {
    $(fetchOnPageLoad).each(function () {
      var $container = $(this);
      var $spinOnFetch = $($container.data('spin-on-fetch'));
      $spinOnFetch.spin();
      $.ajax({
        url: $container.data('fetch-on-load'),
        beforeSend: function (xhr) { xhr.setRequestHeader('Vary', 'X-Requested-With'); }
      }).done(function (response) {
        $container.html(response);
        $container.trigger('reverb.ajax_load.complete');
        $spinOnFetch.stopSpinner();
      });
    });
  }

  return {
    init: init
  };
}());

$(document).ready(Reverb.AjaxFetchOnPageLoad.init);



// WEBPACK FOOTER //
// ./javascripts/components/legacy/ajax_fetch_on_page_load.js